import {Component, OnInit} from '@angular/core';
import {Document} from '../documents/document-countries/document-countries.component';

@Component({
  selector: 'app-payment-information',
  templateUrl: './payment-information.component.html',
})
export class PaymentInformationComponent implements OnInit {
  countries: Array<Document> = [
    {
      countryName: 'Казахстан',
      img: 'kz.svg',
      docHref: 'payment-information-kz.html'
    },
    {
      countryName: 'Беларусь',
      img: 'by.svg',
      docHref: 'payment-information-by.html'
    },
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

}
